module.exports = __webpack_public_path__ + "static/media/caixas_termicas.50686fad.jpg";